import styled from "styled-components";

import { media } from "constants/media";

export const Container = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 20px;
    margin-top: 56px;

    ${media.lgUp} {
        margin-bottom: 40px;
        margin-top: 107px;
    }
`;

export const Title = styled.h1`
    color: var(--color-brown-50);
    font-family: var(--font-secondary);
`;
